import type { RouteRecordRaw } from "vue-router";

export const chatRoutes: RouteRecordRaw[] = [
  // Public assistants - standalone route with parent layout (no auth required)
  // Must be defined BEFORE /ai/chats to take precedence over the catch-all children
  {
    path: "/ai/chats/public_assistants/:id",
    component: () =>
      import("./chats.public_assistants/PublicAssistantLayout.vue"),
    children: [
      {
        path: "",
        name: "ai_assistant-show-public",
        component: () =>
          import("./chats.public_assistants/[id]/PublicAssistantChatPage.vue"),
      },
    ],
  },
  // AI Chat - parent layout with nested children
  {
    path: "/ai/chats",
    component: () => import("./ChatLayout.vue"),
    meta: {
      requiresAuth: true,
      namespace: "ai_chat",
    },
    children: [
      {
        path: "",
        name: "ai_chat-index",
        // Renders the same component as /ai/chats/new - both are entry points for new chats
        component: () => import("./chats/new.vue"),
      },
      {
        path: "new",
        name: "ai_chat-new",
        component: () => import("./chats/new.vue"),
        meta: {
          title: "tools_meta.ai_chat_prefix",
        },
      },
      {
        path: "assistants",
        name: "ai_chat-assistants-index",
        component: () => import("./chats/assistants/ChatAssistantListPage.vue"),
        meta: {
          title: "tools_meta.ai_chat_prefix",
        },
      },
      {
        path: "assistants/my",
        name: "ai_chat-assistants-my",
        component: () =>
          import("./chats/assistants/my/ChatMyAssistantListPage.vue"),
        meta: {
          title: "tools_meta.ai_chat_prefix",
        },
      },
      // Custom assistants - parent with children (nested inside chats layout)
      {
        path: "assistants/:id",
        name: "ai_chat-assistants-show",
        component: () => import("./chats/assistants/ChatAssistantLayout.vue"),
        meta: {
          title: "tools_meta.ai_chat_prefix",
        },
        children: [
          {
            path: "settings",
            name: "ai_chat-assistants-settings",
            component: () => import("./chats/assistants/[id]/settings.vue"),
            meta: {
              title: "tools_meta.ai_chat_prefix",
            },
          },
          {
            path: "share",
            name: "ai_chat-assistants-share",
            component: () => import("./chats/assistants/[id]/share.vue"),
            meta: {
              title: "tools_meta.ai_chat_prefix",
            },
          },
        ],
      },
      {
        path: "info",
        name: "ai_chat-info",
        component: () => import("./chats/info.vue"),
        meta: {
          namespace: "ai_chat",
          title: "tools_meta.ai_chat_prefix",
        },
      },
      // Dynamic :id routes must come LAST to avoid catching static paths
      {
        path: ":id",
        name: "ai_chat-show",
        component: () => import("./chats/ChatLayout.vue"),
        meta: {
          title: "tools_meta.ai_chat_prefix",
        },
      },
      {
        path: ":id/system_prompt",
        name: "ai_chat-system-prompt",
        component: () =>
          import("./chats/[id]/system_prompt/ChatSystemPromptPage.vue"),
        meta: {
          title: "tools_meta.ai_chat_prefix",
        },
      },
    ],
  },
];
